import { useMemo } from "react";
import { daysInMonth } from "../../../utils/dateHelper";

const useDisplayDays = (currentDate: Date) => {
  return useMemo(() => {
    const days = [];
    const firstDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      1,
      currentDate.getHours(),
      currentDate.getMinutes()
    );
    const firstDayOfMonthInAWeek = firstDayOfMonth.getDay();
    const lastDayOfMonth = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      daysInMonth(currentDate.getFullYear())[currentDate.getMonth()],
      currentDate.getHours(),
      currentDate.getMinutes()
    );
    for (let i = firstDayOfMonthInAWeek; i > 0; i--) {
      days.push(
        new Date(
          firstDayOfMonth.getFullYear(),
          firstDayOfMonth.getMonth(),
          firstDayOfMonth.getDate() - i,
          firstDayOfMonth.getHours(),
          firstDayOfMonth.getMinutes()
        )
      );
    }
    for (
      let i = firstDayOfMonth.getDate();
      i <= lastDayOfMonth.getDate();
      i++
    ) {
      days.push(
        new Date(
          firstDayOfMonth.getFullYear(),
          firstDayOfMonth.getMonth(),
          i,
          firstDayOfMonth.getHours(),
          firstDayOfMonth.getMinutes()
        )
      );
    }

    if (days.length < 36) {
      const curLength = days.length;
      for (let i = 0; i < 35 - curLength; i++) {
        days.push(
          new Date(
            firstDayOfMonth.getFullYear(),
            firstDayOfMonth.getMonth() + 1,
            i + 1,
            firstDayOfMonth.getHours(),
            firstDayOfMonth.getMinutes()
          )
        );
      }
    }

    return days;
  }, [currentDate]);
};

export default useDisplayDays;
